import {Component, Input, OnChanges, SimpleChanges, ViewChild} from '@angular/core';
import {Observable} from 'rxjs';
import {ModalComponent} from '../modal/modal.component';

@Component({
  selector: 'reviews-help-modal',
  templateUrl: './reviews-help-modal.component.html',
  styleUrls: ['./reviews-help-modal.component.scss'],
  // changeDetection: ChangeDetectionStrategy.OnPush
})
export class ReviewsHelpModalComponent implements OnChanges {

  @Input() trigger: Observable<void>;

  @ViewChild('modal') modal: ModalComponent;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['trigger'] && this.trigger) {
      this.trigger.subscribe(() => this.modal.show());
    }
  }
}
